import Vue from 'vue'; // 引入 Vue 2
import App from './App.vue'; // 引入根组件
import router from './router'; // 引入路由
import store from './store'; // 引入 Vuex store
import locale from 'element-ui/lib/locale/lang/en'

import ElementUI from 'element-ui'; // 引入 Element UI
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 样式

import axios from './common/axios.config'; // 引入 axios 配置实例
import '@/permission' // permission control

import cn from "./lang/cn.json";
import hk from "./lang/hk.json";
import en from "./lang/en.json";

Vue.config.productionTip = false; // 关闭生产模式提示

// 使用 Element UI 插件
Vue.use(ElementUI);

// 将 axios 挂载到 Vue 实例上
Vue.prototype.$ajax = axios;
let region = 'cn'
// BaseUrl='http://gpt4.cocorobo.cn:8011/';
if (parent?.location?.href.includes('beta') || window?.location?.href.includes('localhost')) {
  console.log(parent.location.href);
  
  region = 'beta'
} else if (parent?.location?.href.includes('cn')) {
  console.log(parent.location.href);
  region = 'cn'
} else if (parent?.location?.href.includes('hk')) {
  console.log(parent.location.href);
  region = 'hk'
} else if (parent?.location?.href.includes('com')) {
  console.log(parent.location.href);
  region = 'com'
} 
console.log('region',region);
//注册到vue原型上
let lang = new Object();
let domain_name=""

if (parent?.location?.href.includes("cn")) {
  domain_name="cn";
  lang = cn;
} else if (parent?.location?.href.includes("hk")) {
  domain_name="hk";
  lang = hk;
} else if (parent?.location?.href.includes("com")) {
  domain_name="com";
  lang=en;
}else{
  domain_name="cn";
  lang=cn;
}
Vue.prototype.lang =lang;

if(domain_name==='com'){//英文版
	Vue.use(ElementUI,{locale})
}else{
	Vue.use(ElementUI)
}

Vue.prototype.$region = region;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

export { region }